module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/7ce197172287887ac173f361ca360f02.png";